var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"glz animation srcospcur"},[(_vm.list.length>0)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.list[0].content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }